(() => {
  let opener = null;
  let expires = null;
  let frame = null;
  let settingsOpener = null;

  const clear = () => {
    opener = null;
    window.clearTimeout(expires);
    window.cancelAnimationFrame(frame);
    expires = null;
    frame = null;
  };

  const closeButtonFor = (banner) => {
    if (!banner || banner.getAttribute('aria-hidden') === 'true' || banner.getClientRects().length === 0) return null;
    return Array.from(banner.querySelectorAll('button.CybotCookiebotBannerCloseButton')).find((button) => {
      const style = window.getComputedStyle(button);
      return !button.disabled && button.getClientRects().length > 0 && style.visibility === 'visible' && style.display !== 'none';
    });
  };

  document.addEventListener('keydown', (event) => {
    clear();
    if (event.key === 'Escape' && !event.repeat && !event.defaultPrevented && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
      const banner = document.getElementById('CybotCookiebotDialog');
      if (!banner?.contains(event.target) || !banner.contains(document.activeElement)) return;
      const closeButton = closeButtonFor(banner);
      if (!closeButton) return;
      event.preventDefault();
      event.stopPropagation();
      closeButton.click();
      return;
    }
    if (event.key !== 'Enter' || event.repeat || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
    const trigger = event.target.closest?.('#CookieDeclarationChangeConsentChange');
    if (!trigger || document.activeElement !== trigger) return;
    opener = trigger;
    expires = window.setTimeout(clear, 5000);
  }, true);

  document.addEventListener('pointerdown', clear, true);
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-leslis-consent-open]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || typeof window.Cookiebot?.renew !== 'function') return;
    event.preventDefault();
    clear();
    settingsOpener = trigger;
    if (event.detail === 0) {
      opener = trigger;
      expires = window.setTimeout(clear, 5000);
    }
    window.Cookiebot.renew();
  });
  document.addEventListener('focusin', (event) => {
    if (opener && event.target !== opener) clear();
  }, true);

  window.addEventListener('CookiebotOnDialogDisplay', () => {
    if (!opener) return;
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => {
      const trigger = opener;
      clear();
      if (!trigger?.isConnected || document.activeElement !== trigger) return;
      const closeButton = closeButtonFor(document.getElementById('CybotCookiebotDialog'));
      closeButton?.focus({ preventScroll: true });
    });
  });

  window.addEventListener('CookiebotOnDialogHide', () => {
    const trigger = settingsOpener;
    settingsOpener = null;
    const banner = document.getElementById('CybotCookiebotDialog');
    if (trigger?.isConnected && (document.activeElement === document.body || banner?.contains(document.activeElement))) {
      trigger.focus({ preventScroll: true });
    }
  });
})();
